<template lang="pug">
transition(name="navigate", appear, mode="out-in")
  slot
</template>

<script>
export default {
  name: "Navigate",
};
</script>

<style lang="scss">
.navigate-enter-active,
.navigate-leave-active {
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-property: opacity, transform;
}
.navigate-enter {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.navigate-leave-to {
  opacity: 0;
  transform: translateX(30px);
  z-index: 1;
}
</style>